import { PrayerDisplay } from '../types/prayer';

interface SinglePrayerViewProps {
  prayer: PrayerDisplay;
  timeUntilNext: string;
}

export function SinglePrayerView({ prayer, timeUntilNext }: SinglePrayerViewProps) {
  return (
    <div className="h-screen w-screen fixed inset-0 bg-gradient-to-br from-emerald-900 via-teal-800 to-emerald-900 flex items-center justify-center overflow-hidden">
      <div className="w-full flex flex-col items-center justify-center px-4 py-6 gap-3 sm:gap-6 md:gap-8 max-w-6xl mx-auto">
        <div
          className="font-bold text-white leading-tight text-center"
          style={{
            fontSize: 'clamp(1.75rem, 8vw, 16rem)',
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5))'
          }}
        >
          {prayer.nameArabic}
        </div>

        <div
          className="font-black text-gray-800 bg-white/95 px-4 py-3 sm:px-10 sm:py-6 md:px-12 md:py-8 rounded-xl sm:rounded-2xl md:rounded-3xl shadow-2xl"
          style={{
            fontSize: 'clamp(1.75rem, 8vw, 12rem)',
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
            lineHeight: '1.1'
          }}
        >
          {prayer.name}
        </div>

        <div
          className="font-extrabold text-white leading-tight text-center"
          style={{
            fontSize: 'clamp(2.25rem, 10vw, 16rem)',
            filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.5))'
          }}
        >
          {prayer.time}
        </div>

        {timeUntilNext && (
          <div>
            <span
              className="inline-block bg-red-500/90 backdrop-blur-sm px-5 py-2.5 sm:px-10 sm:py-5 md:px-12 md:py-6 rounded-full font-bold text-white animate-pulse shadow-2xl"
              style={{
                fontSize: 'clamp(1.125rem, 5vw, 8rem)',
                filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.4))'
              }}
            >
              {timeUntilNext}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
